import React, { useState, useCallback, useEffect } from 'react';

// ASSETS
import { InitialIcon, CurrentIcon, DoneIcon, DeniedIcon, WaiverIcon } from './assets/svgs';

// COMPONENTS
import Tooltip from '../Tooltip';
import Skeleton from '../Skeleton';

// ENUMS
import { SkeletonTypes } from '../../enums/skeletonTypes';
import { Status } from '../../enums/status';
import { TooltipOrigins } from '../../enums/tooltips';

// INTERFACES
import { IStepCardProps } from '../../interfaces/StepCard.interface';

// STYLES
import { Container, Title, IconContainer, Days, Number } from './styles';

const StepCard: React.FC<IStepCardProps> = ({
  label,
  tooltip = '',
  status = Status.INITIAL,
  onClick,
  number,
  isOpened = true,
  isLoading = false,
  isMobile,
  totalDays
}: IStepCardProps) => {
  const iconByStatus = {
    [Status.INITIAL]: <InitialIcon />,
    [Status.CURRENT]: <CurrentIcon />,
    [Status.DONE]: <DoneIcon />,
    [Status.DENIED]: <DeniedIcon />
  };

  const [hoverActive, setHoverActive] = useState(false);
  const onHoverCard = useCallback(() => {
    setTimeout(function () {
      setHoverActive(true);
    }, 3000);
  }, []);

  useEffect(() => {
    if (status == Status.CURRENT) {
      onClick;
    }
  }, [status]);

  return (
    <>
      {!isLoading ? (
        <Container
          status={status}
          onClick={onClick}
          onMouseOver={onHoverCard}
          onMouseOut={() => setHoverActive(false)}
          className={isOpened ? 'Active' : ''}
        >
          <Tooltip origin={TooltipOrigins.CARD} title={tooltip} active={hoverActive}>
            <IconContainer>{iconByStatus[status] || <WaiverIcon />}</IconContainer>
            {(!isMobile || isOpened) && <Title status={status}>{label}</Title>}
            {isMobile && !isOpened && <Number status={status}>{number}</Number>}
            {(!isMobile || isOpened) && totalDays != '' && <Days status={status}>{totalDays}</Days>}
          </Tooltip>
        </Container>
      ) : (
        <Skeleton type={SkeletonTypes.CARD} />
      )}
    </>
  );
};

export default StepCard;
